import ReportsAdapter from './base';

export default class StudentReportSection extends ReportsAdapter {
  modelNamePlural = 'student-report-sections';
}
